document.addEventListener("DOMContentLoaded", function () {
  const products = document.querySelectorAll("#product-grid li.grid__item");
  const counterDiv = document.querySelector(".st-counter");

  if (!counterDiv) {
    console.warn("⚠️ .st-counter not found");
    return;
  }

  const viewCountEl = counterDiv.querySelector(".view-count");
  const totalCountEl = counterDiv.querySelector(".total-count-product");

  if (products.length === 0) {
    console.warn("⚠️ No products found");
    return;
  }

  const currentPage = getCurrentPage();
  const perPage = products.length;
  const totalProducts = window.stPagination?.totalProducts || perPage;

  totalCountEl.textContent = " / " + totalProducts;

  const pageOffset = (currentPage - 1) * 36;

  function updateViewCount() {
    let lastVisibleIndex = 0;
    const winHeight = window.innerHeight;

    products.forEach((product, i) => {
      const rect = product.getBoundingClientRect();
      if (rect.top < winHeight && rect.bottom > 0) {
        lastVisibleIndex = i + 1;
      }
    });

    const count = pageOffset + lastVisibleIndex;
    viewCountEl.textContent = count;

    if (count >= 6) {
      counterDiv.style.display = "flex";
    } else {
      counterDiv.style.display = "none";
    }
  }

  updateViewCount();
  window.addEventListener("scroll", updateViewCount);
  window.addEventListener("resize", updateViewCount);

  // ✅ Footer detection
  const footer = document.querySelector("footer.footer");
  if (!footer) {
    console.warn("⚠️ Footer not found");
  } else {
    console.log("✅ Footer found:", footer);

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.log("👀 Footer in view → hiding counter");
          counterDiv.style.display = "none";
        } else {
          console.log("👀 Footer out of view → updating counter");
          updateViewCount();
        }
      });
    }, { threshold: 0.1 });

    observer.observe(footer);
  }

  function getCurrentPage() {
    const url = new URL(window.location.href);
    return parseInt(url.searchParams.get("page") || "1", 10);
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const products = document.querySelectorAll("#product-grid li.grid__item");
  products.forEach(product=>{
    product.addEventListener("click", () => {
      const productId = product.getAttribute("data-product-id");
      if (productId) {
        sessionStorage.setItem("visitedProduct", productId);
      }
    });
  });
  let visitedProduct = sessionStorage.getItem("visitedProduct") || sessionStorage.getItem("searchVisitedProduct");
  if (visitedProduct) {
    let product = document.querySelector(`#product-grid li.grid__item[data-product-id="${visitedProduct}"]`);
    if (product) {
      product.scrollIntoView({ behavior: "smooth", block: "end" });
    }
    sessionStorage.removeItem('visitedProduct');
  }

  const target = document.querySelector('.st-filter-sort-wrap');

  function updateTargetHeight() {
    if (target) {
      const header = document.querySelector('.section-header.shopify-section-group-header-group');
      if (header) {
        const headerHeight = header.getBoundingClientRect().height;
        const totalHeight = headerHeight;
        target.style.top = totalHeight + 'px';
      }
    }
  }

  const observer = new ResizeObserver(updateTargetHeight);
  const header = document.querySelector('.section-header.shopify-section-group-header-group');
  if (header) observer.observe(header);
  // Initial run
  setTimeout(updateTargetHeight, 100);
});



function checkFooter() {
  const footer = document.querySelector("footer.footer.color-inverse.gradient");
  const counterDiv = document.querySelector(".st-counter");

  if (!footer || !counterDiv) return;

  const footerRect = footer.getBoundingClientRect();
  const inView = footerRect.top < window.innerHeight && footerRect.bottom >= 0;

  if (inView) {
    console.log("👀 Footer in view → adding hidden class");
    counterDiv.classList.add("st-hidden");
  } else {
    counterDiv.classList.remove("st-hidden");
  }
}

window.addEventListener("scroll", checkFooter);







// this is the function for toggling number of product in a row
function toggleProductGrid(lines) {
    const productGrid = document.getElementById('product-grid');
    
    productGrid.classList.remove('grid--2-col-desktop');
    productGrid.classList.remove('grid--3-col-desktop');
    productGrid.classList.remove('grid--4-col-desktop');
  productGrid.classList.remove('grid--5-col-desktop');
    
     if (lines === 3) {
        productGrid.classList.add('grid--3-col-desktop');
    } else if (lines === 4) {
        productGrid.classList.add('grid--4-col-desktop');
    }
  else if (lines === 5) {
        productGrid.classList.add('grid--5-col-desktop');
    } 
    const gridButtons = document.querySelectorAll('.st-grid-changer button');
const currentColumns = parseInt(lines); // Assuming 'lines' is the variable containing the current column value

gridButtons.forEach(button => {
    const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
    const isActive = button.classList.contains('active');

    if (buttonColumns === currentColumns && !isActive) {
        button.classList.add('active'); // Add 'active' class
    } else if (buttonColumns !== currentColumns && isActive) {
        button.classList.remove('active'); // Remove 'active' class
    }
});

}



document.addEventListener("DOMContentLoaded", function() {
    const scrollAmount = 300;

    // Function to scroll the container element horizontally
    const scrollContainer = (container, direction) => {
        const scrollLeft = container.scrollLeft;
        let targetScrollLeft;

        if (direction === 'left') {
            targetScrollLeft = scrollLeft - scrollAmount;
        } else if (direction === 'right') {
            targetScrollLeft = scrollLeft + scrollAmount;
        }

        // Smooth scroll transition
        container.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth'
        });

        toggleArrowsVisibility(container);
    };

    // Function to toggle arrows visibility based on scroll position
    const toggleArrowsVisibility = (container) => {
        const leftArrow = container.querySelector('.left-arrow');
        const rightArrow = container.querySelector('.right-arrow');
        if (container.scrollLeft === 0 && leftArrow) {
            leftArrow.style.visibility = 'hidden';
        } else if(leftArrow) {
            leftArrow.style.visibility = 'visible';
        }
        if (container.scrollLeft + container.clientWidth >= container.scrollWidth && rightArrow) {
            rightArrow.style.visibility = 'hidden';
        } else if(rightArrow) {
            rightArrow.style.visibility = 'visible';
        }
    };

    // Select all link-list-wrapper containers
    const containers = document.querySelectorAll('.link-list-wrapper');

    // Add event listeners for each container
    containers.forEach(container => {
        const leftArrow = container.querySelector('.left-arrow');
        const rightArrow = container.querySelector('.right-arrow');

        if (leftArrow) {
            leftArrow.addEventListener('click', () => {
                scrollContainer(container, 'left');
            });
        }

        if (rightArrow) {
            rightArrow.addEventListener('click', () => {
                scrollContainer(container, 'right');
            });
        }

        // Toggle arrows visibility initially
        toggleArrowsVisibility(container);
    });

    // Add resize event listener to adjust arrows visibility on window resize
    window.addEventListener('resize', () => {
        containers.forEach(container => {
            toggleArrowsVisibility(container);
        });
    });
});


/*
   scroll to top behaviour on scroll in collection pages
*/
document.addEventListener("DOMContentLoaded", () => {
  let backToTop = document.querySelector(".st-collection-scroll-top");

  if (backToTop) {
    // scroll-to-top on click
    backToTop.addEventListener("click", () => {
      document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }

  window.addEventListener("scroll", () => {
    if (backToTop && window.scrollY > 250) {
      backToTop.style.display = "flex";
    } else if (backToTop && window.scrollY <= 250) {
      backToTop.style.display = "none";
    }
  });
});

/*
   below mutation observer is to remove currency postfix from all the span with class money
*/

function removeDoublyCurrencyValues() {
    const moneySpans = document.querySelectorAll('span.money');

    moneySpans.forEach(span => {
        const doublyCurrencyValue = span.getAttribute('doubly-currency');
        if (doublyCurrencyValue) {
            const innerText = span.innerHTML.replace(doublyCurrencyValue, '').trim();
            span.innerHTML = innerText;
        }
    });
}

// Recursive function to check for the addition of 'doubly-currency' attribute within a time limit
function observeForAttributeAddition(startTime) {
    const currentTime = new Date().getTime();

    if (currentTime - startTime >= 5000) {
        console.log("Timeout: No 'doubly-currency' attribute added within 5 seconds.");
        return;
    }

    const moneySpans = document.querySelectorAll('span.money');

    for (const span of moneySpans) {
        if (span.getAttribute('doubly-currency') !== null) {
            removeDoublyCurrencyValues();
            return;
        }
    }

    // Set up MutationObserver to monitor changes in the DOM
    const observer = new MutationObserver(mutationsList => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'doubly-currency') {
                removeDoublyCurrencyValues();
                observer.disconnect();
                return;
            }
        }
    });

    observer.observe(document.body, { subtree: true, attributes: true });
}

// Call observeForAttributeAddition when DOM content is loaded
document.addEventListener('DOMContentLoaded', () => {
    const startTime = new Date().getTime();
    observeForAttributeAddition(startTime);
});